/**
 * 创建人：王靖
 * 时间：2019-3-29
 * 描述：notice:成功 信息 警告 错误
 * 更新记录: 
 */
import { Component, Input, Output, EventEmitter, OnInit} from '@angular/core';


@Component({
  selector: 'sw-notice',
  templateUrl: './sw-notice.component.html',
  styleUrls: ['./sw-notice.component.css']
})
export class SwNoticeComponent implements OnInit {
  @Input() message: string;   //显示数据
  @Input() type: string; //显示类型  s i w e   
  @Output() voted = new EventEmitter(); //自动关闭事件

  constructor() { }

  ngOnInit() {
    //定时自动关闭属性 默认3秒
    setTimeout(() => this.voted.next(), 3000);
  }
}
